import Inputmask from 'inputmask'

export default {
	bind: function (el, binding) {
		if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
			const els = el.getElementsByTagName('input')
			if (els.length !== 1) {
				throw new Error('v-input-mask directive requires 1 input, found ' + els.length)
			} else {
				mask(els[0], binding)
			}
		} else {
			mask(el, binding)
		}
	},
}

function mask(el, binding) {
	const defaultOptions = { showMaskOnHover: false, casing: 'upper' }
	Inputmask(Object.assign(defaultOptions, binding.value)).mask(el)
}
